//Partner Logos
import dynamiqueLogo from "../images/trainingPartners/Dynamique Logo.png"
import dacreedTrainingPartnersLogo from "../images/trainingPartners/Dacreed training partners big.png"
import PIQLogo from "../images/trainingPartners/PIQ-full-colour-RGB.png"
import spongeLogo from "../images/trainingPartners/Sponge Logo.png"
import avenLogo from "../images/trainingPartners/aven 1.png"
import foxHubLogo from "../images/trainingPartners/fox-hub-2 1.png"

interface TrainingPartner {
  name: string
  logo: string
  brief: string
  webLink: string
  pinToTop?: boolean
}

function shuffle<T>(array: T[]): T[] {
  return array.sort(() => Math.random() - 0.5)
}

function shufflePartners(partners: TrainingPartner[]): TrainingPartner[] {
  const pinned = shuffle(partners.filter((partner) => partner.pinToTop))
  const other = shuffle(partners.filter((partner) => !partner.pinToTop))
  return [...pinned, ...other]
}

export const trainingPartnerData: TrainingPartner[] = shufflePartners([
  {
    name: "Professional IQ",
    logo: PIQLogo,
    brief:
      "NZQA Qualifications, Professional Development and Training for Financial Advisers from the only PTE that focusses solely on the financial services industry.",
    webLink: "https://professionaliq.co.nz/",
    pinToTop: true,
  },
  {
    name: "Rosewill Consulting ",
    logo: avenLogo,
    brief:
      "We help small and medium size entities meet their regulatory obligations by providing simple and sustainable compliance solutions.",
    webLink: "",
    pinToTop: false,
  },
  {
    name: "Sponge",
    logo: spongeLogo,
    brief: "TBA",
    webLink: "",
    pinToTop: false,
  },
  {
    name: "Trevor Slater",
    logo: foxHubLogo,
    brief:
      "Everything you need to know about managing compliants and disputes in the fincnail services industry written by one of New Zealand's leading experts ",
    webLink: "/training-partners/trevor-slater",
    pinToTop: false,
  },
  {
    name: "Dynamique",
    logo: dynamiqueLogo,
    brief:
      "Comprehensive compliance training on all aspects of financial services ",
    webLink: "/training-partners/dynamique",
    pinToTop: false,
  },
  {
    name: "Dacreed Training Partners ",
    logo: dacreedTrainingPartnersLogo,
    brief:
      "A free set of sample courses from Dacreed's Training Partner Program so you can find the partners that suit you best.",
    webLink: "",
    pinToTop: false,
  },
])
